import { motion } from "framer-motion";

export default function About() {
  return (
    <section className="mt-12 sm:mt-[5rem] mb-12 sm:mb-[6rem] max-w-[100%] mx-auto">
      {/* About Us Heading with hover underline effect */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-semibold relative inline-block group">
          <span className="relative z-10 text-brandRed">About Us</span>
          <span className="absolute left-0 bottom-0 h-1 bg-brandRed transition-all duration-300 w-0 group-hover:w-full"></span>
        </h1>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center space-y-8 md:space-y-0 px-4 md:px-8">
        {/* Image Section */}
        <motion.div
          className="md:w-1/2"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <img
            src="https://media.istockphoto.com/id/1498170916/photo/a-couple-is-taking-a-bag-of-food-at-the-food-and-clothes-bank.jpg?s=612x612&w=0&k=20&c=0fnD_g46lvoZ5NdzX5zYOSM4PzM95ezfs5uMe9D1QKs="
            alt="Volunteers providing food and support to community members"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </motion.div>

        {/* Text Section */}
        <motion.div
          className="md:w-1/2 text-center md:text-left px-4 md:px-12 font-body"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <h2 className="text-3xl font-semibold mb-4 text-brandRed font-body">
            About Hope for Humanity
          </h2>
          {/* <p className="text-lg text-gray-600 leading-relaxed mb-6">
            Hope for Humanity is a non-profit organization dedicated to making a
            difference in the world. We focus on empowering underserved
            communities through education, healthcare, and sustainable
            development programs. Our mission is to bring hope, compassion, and
            resources to those in need.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mb-6">
            We believe in a world where every person has the opportunity to
            thrive, regardless of their background or circumstances. Join us in
            our mission to create lasting change and build a brighter future for
            all.
          </p> */}
          {/* Added summarized objectives text */}
          <p className="text-lg text-gray-600 leading-relaxed">
            The Society, established by Roman Catholics in Vasai, works towards
            holistic community development through initiatives in education,
            healthcare, women and child welfare, rural development, cultural
            growth, disaster relief, and socio-spiritual activities. By
            supporting marginalized groups, promoting awareness, and
            collaborating with government and voluntary organizations, it
            strives to ensure sustainable development, social equity, and
            community well-being.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
